import '../style/menu-CNqQuDhA.css'
import { ref as T, computed as p, defineComponent as $, useSlots as U, useModel as K, watch as F, provide as H, openBlock as r, createBlock as _, unref as g, mergeProps as z, isRef as j, withCtx as k, createElementBlock as v, Fragment as I, renderSlot as B, createVNode as N, normalizeProps as G, guardReactiveProps as Z, inject as E, onBeforeUnmount as q, normalizeClass as A, renderList as L, createCommentVNode as b, createTextVNode as D, toDisplayString as C, createElementVNode as P, normalizeStyle as J } from "vue";
import Q from "./popper.js";
import x from "./icon.js";
import { useKeyboardNavigation as W } from "./hooks/useKeyboardNavigation.js";
import { shortUUID as X } from "./utils/uuid.js";
import Y from "./link.js";
import O from "./badge.js";
import { DEFAULT_SIZE as ee } from "./constant/common.js";
import { useComponentClassList as te } from "./hooks/useComponentClassList.js";
function ne(m, a, n, t, u) {
  const s = T(-1), i = "keydown", e = p(() => n.value?.popperNode || document.createElement("div")), c = T([]), { focusIndex: y } = W({
    watchSource: t,
    wrapperRef: e,
    selector: ".e-menu-item"
  }), h = {
    theme: m.theme,
    selectedIndex: p(() => s.value),
    children: c,
    addChild: (l, d) => {
      c.value.push({ id: l, value: d });
    },
    removeChild: (l) => {
      const d = c.value.findIndex((w) => w.id === l);
      c.value.splice(d, 1);
    },
    onSelect: (l, d = !0) => {
      a("select", l), s.value = l.index, d && u(l);
    },
    focusIndex: y
  };
  return {
    selectedIndex: s,
    event: i,
    provider: h
  };
}
const M = Symbol("menuKey"), ye = /* @__PURE__ */ $({
  name: "e-menu",
  __name: "menu",
  props: {
    modelValue: {},
    open: { type: Boolean, default: !1 },
    placement: { default: "bottom-start" },
    transition: { default: "slide" },
    lazy: { type: Boolean, default: !0 },
    to: {},
    newTab: { type: Boolean },
    triggerByHover: { type: Boolean, default: !0 },
    offsetDistance: { default: 6 },
    closeOnSelect: { type: Boolean, default: !0 },
    autoSelect: { type: Boolean, default: !0 },
    theme: {},
    size: {},
    triggerArrow: { type: Boolean, default: !0 },
    triggerArrowIcon: { default: "chevron-down" },
    renderTriggerButton: { type: Boolean, default: !0 },
    triggerButton: {},
    triggerStyle: {}
  },
  emits: ["select", "update:open"],
  setup(m, { emit: a }) {
    const n = m, t = a, { theme: u, triggerArrow: s } = n, i = U(), e = K(n, "open", { local: !0 }), c = T(null), { provider: y } = ne(
      n,
      t,
      c,
      e,
      () => {
        n.closeOnSelect && (e.value = !1);
      }
    ), h = p(() => !!i?.content), l = p(() => s && h.value ? {
      icon: n.triggerArrowIcon,
      rotation: e.value ? 180 : 0,
      size: "16"
    } : null), d = p(() => n.renderTriggerButton ? {
      colorScheme: "plain",
      text: !0,
      ...n.triggerButton
    } : void 0), w = (o) => {
      e.value = o;
    };
    return F(e, (o) => {
      if (o && n.autoSelect) {
        const S = y.children.value[0]?.value;
        y.onSelect({ index: 0, value: S }, !1);
      }
    }), H(M, y), (o, f) => (r(), _(g(Q), z({
      ref_key: "menuNode",
      ref: c
    }, o.$attrs, {
      modelValue: g(e),
      "onUpdate:modelValue": f[0] || (f[0] = (S) => j(e) ? e.value = S : null),
      variant: "menu",
      lazy: o.lazy,
      theme: g(u),
      placement: o.placement,
      transition: o.transition,
      "offset-distance": o.offsetDistance,
      "trigger-by-hover": o.triggerByHover,
      "trigger-style": o.triggerStyle,
      "trigger-button-props": d.value,
      "trigger-ripple": o.renderTriggerButton,
      onToggle: w
    }), {
      default: k(() => [
        o.renderTriggerButton ? (r(), v(I, { key: 0 }, [
          B(o.$slots, "default"),
          N(g(x), G(Z(l.value)), null, 16)
        ], 64)) : B(o.$slots, "default", { key: 1 })
      ]),
      content: k(() => [
        B(o.$slots, "content")
      ]),
      _: 3
    }, 16, ["modelValue", "lazy", "theme", "placement", "transition", "offset-distance", "trigger-by-hover", "trigger-style", "trigger-button-props", "trigger-ripple"]));
  }
}), R = /* @__PURE__ */ $({
  name: "e-menu-item",
  __name: "menu-item",
  props: {
    to: {},
    newTab: { type: Boolean },
    value: {}
  },
  emits: ["click"],
  setup(m, { emit: a }) {
    const n = m, t = E(M), u = a, { selectedIndex: s, children: i, addChild: e, removeChild: c, onSelect: y, focusIndex: h } = t, l = X();
    e(l), q(() => {
      c(l);
    });
    const d = p(() => i.value.findIndex((f) => f.id === l)), w = p(() => [
      "e-menu-item",
      {
        selected: s.value === d.value,
        focused: h.value === d.value
      }
    ]), o = () => {
      u("click"), y({ index: d.value, value: n.value });
    };
    return (f, S) => (r(), _(g(Y), {
      to: f.to,
      class: A(w.value),
      "new-tab": f.newTab,
      ripple: !0,
      "a11y-attrs": {
        role: "menuitem",
        tabindex: "-1"
      },
      onClick: o
    }, {
      default: k(() => [
        B(f.$slots, "default")
      ]),
      _: 3
    }, 8, ["to", "class", "new-tab"]));
  }
}), V = "e-menu-list", _e = /* @__PURE__ */ $({
  name: V,
  __name: "menu-list",
  props: {
    size: { default: ee },
    items: { default: () => [] }
  },
  setup(m) {
    const a = m, { theme: n } = E(M), t = te(V, {
      size: a.size
    }), u = p(() => {
      const s = [...t.value];
      return n && s.push(`e-menu-list--${n}`), s;
    });
    return (s, i) => (r(), v("div", {
      class: A(u.value),
      role: "menu"
    }, [
      s.items.length ? (r(!0), v(I, { key: 0 }, L(s.items, (e, c) => (r(), _(R, {
        key: c,
        to: e.to,
        value: e.value
      }, {
        default: k(() => [
          e.icon ? (r(), _(g(x), z({
            key: 0,
            ref_for: !0
          }, e.icon), null, 16)) : b("", !0),
          D(" " + C(e.text) + " ", 1),
          e.badge ? (r(), _(g(O), z({
            key: 1,
            ref_for: !0
          }, e.badge), null, 16)) : b("", !0)
        ]),
        _: 2
      }, 1032, ["to", "value"]))), 128)) : B(s.$slots, "default", { key: 1 })
    ], 2));
  }
}), oe = { class: "e-menu-pane-item__title" }, re = {
  key: 0,
  class: "e-menu-pane-item__desc"
}, se = /* @__PURE__ */ $({
  __name: "menu-pane-item",
  props: {
    menus: { default: () => [] }
  },
  setup(m) {
    return (a, n) => (r(!0), v(I, null, L(a.menus, (t, u) => (r(), _(R, {
      key: `pane-item-${u}`,
      to: t.to,
      "new-tab": t.newTab,
      class: "e-menu-pane-item"
    }, {
      default: k(() => [
        N(g(x), {
          icon: t.icon,
          svg: t.svg,
          size: 32,
          class: "e-menu-pane-item__icon"
        }, null, 8, ["icon", "svg"]),
        P("div", oe, [
          D(C(t.text) + " ", 1),
          t.badge ? (r(), _(g(O), z({
            key: 0,
            ref_for: !0
          }, t.badge), null, 16)) : b("", !0)
        ]),
        t.desc ? (r(), v("div", re, C(t.desc), 1)) : b("", !0)
      ]),
      _: 2
    }, 1032, ["to", "new-tab"]))), 128));
  }
}), ae = { class: "e-menu-pane" }, le = {
  key: 0,
  class: "e-menu-pane-name"
}, he = /* @__PURE__ */ $({
  name: "e-menu-pane",
  __name: "menu-pane",
  props: {
    maxRows: { default: 5 },
    iconColor: {},
    iconSize: {},
    items: {}
  },
  setup(m) {
    const a = m, n = p(() => "children" in a.items[0]), t = p(() => n.value ? a.items : [{ children: a.items }]);
    return (u, s) => (r(), v("div", ae, [
      (r(!0), v(I, null, L(t.value, (i, e) => (r(), v("div", {
        key: `pane-${e}`,
        class: "e-menu-pane-group"
      }, [
        i.name ? (r(), v("div", le, C(i.name), 1)) : b("", !0),
        P("div", {
          class: "e-menu-pane-items",
          style: J({ "grid-template-rows": `repeat(${Math.min(i.children.length, u.maxRows)}, 1fr)` })
        }, [
          N(se, {
            menus: i.children
          }, null, 8, ["menus"])
        ], 4)
      ]))), 128))
    ]));
  }
});
export {
  R as MenuItem,
  _e as MenuList,
  he as MenuPane,
  ye as default
};
//# sourceMappingURL=menu.js.map
